import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../selectors/sessionSelectors';

export const useCurrentUser = () => {
	return useSelector(selectCurrentUser);
};
